<template>
    <a-card id="customMenu">
        <a-input style="width: 100%; min-height: 250px;margin-bottom: 20px;"
                 spellcheck="false"
                 v-model="textareaContent"
                 type="textarea"/>
        <a-button @click="save" :loading="saveLoading" type="primary">保存</a-button>
    </a-card>
</template>

<script>
export default {
    name: 'customMenu',
    data() {
        return {
            textareaContent: "",
            saveLoading: false
        }
    },
    mounted() {
        this.getMenu();
    },
    methods:{
        getMenu(){
            this.$http.Base.getMenu().then(res => {
                const {data} = res;
                this.textareaContent = JSON.stringify(data, undefined, 2);
            })
        },
        save(){
            this.$message.destroy();
            let json = null;
            try {
                json = JSON.parse(this.textareaContent)
            } catch (e){
                this.$message.error("JSON格式错误");
                return
            }
            this.saveLoading = true;
            this.$http.Base.menuCreate(json).then(res => {
                const {message} = res;
                this.$message.success(message);
                this.getMenu();
            }).finally(() => {
              this.saveLoading = false;
            })
        }
    }
}
</script>

<style scoped>
#customMenu {
    height: 72.5vh;
}
</style>
